import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDesignatedReviews } from '@/hooks/coaching/useDesignatedReview'
import { ReviewPlacementDialog } from './ReviewPlacementDialog'

interface Props {
  learnerId: number
  lessonId: number
  lessonTitle: string
}

export function ReviewToggle({ learnerId, lessonId, lessonTitle }: Props) {
  const { t } = useTranslation('coaching')
  const { data: reviews, isLoading } = useDesignatedReviews(learnerId)
  const [placementOpen, setPlacementOpen] = useState(false)

  const hasActiveReservation = (reviews ?? []).some(
    (review) => review.reviewLessonId === lessonId && review.placementStatus !== 'COMPLETED',
  )
  if (isLoading || hasActiveReservation) return null

  return (
    <div className="flex flex-col items-end gap-1">
      <button
        type="button"
        onClick={() => setPlacementOpen(true)}
        className="rounded-lg border border-gray-300 bg-white px-3 py-1.5 text-sm font-semibold text-gray-700 hover:bg-gray-50"
      >
        {t('designatedReview.toggle.designate')}
      </button>
      {placementOpen && (
        <ReviewPlacementDialog
          learnerId={learnerId}
          reviewLessonId={lessonId}
          reviewLessonTitle={lessonTitle}
          onClose={() => setPlacementOpen(false)}
        />
      )}
    </div>
  )
}
